export default (string, limit) => {
	const stringWithEllipsis = string.length > limit ? string.substring(0, limit) + '...' : string;
	return stringWithEllipsis;
}
